/**
 * Filtra la clasificación de productos excluyendo filas creadas o espejadas
 * desde el módulo de recetas (columnas `receta_category_id`, `receta_subcategory_id`, `receta_family_id` en el API).
 * Las tablas y listas completas no usan esto; sirve para jerarquía/filtros de producto.
 */

function isProductCategoryNotFromReceta(c) {
  return c == null || c.receta_category_id == null;
}

function isProductSubcategoryNotFromReceta(s) {
  return s == null || s.receta_subcategory_id == null;
}

function isProductFamilyNotFromReceta(f) {
  return f == null || f.receta_family_id == null;
}

/**
 * @param {Array<Record<string, unknown>>} categories
 */
export function filterProductCategoriesExcludingRecetaMirror(categories) {
  return (categories || []).filter(isProductCategoryNotFromReceta);
}

/**
 * @param {Array<Record<string, unknown>>} subcategories
 */
export function filterProductSubcategoriesExcludingRecetaMirror(subcategories) {
  return (subcategories || []).filter(isProductSubcategoryNotFromReceta);
}

/**
 * @param {Array<Record<string, unknown>>} families
 */
export function filterProductFamiliesExcludingRecetaMirror(families) {
  return (families || []).filter(isProductFamilyNotFromReceta);
}

/**
 * Categoría → subcategorías → familias, sin ramas de recetas.
 * @param {Array<{ subcategories?: Array<{ families?: Array }> }>} hierarchy
 */
export function filterProductClassificationHierarchyExcludingRecetaMirror(hierarchy) {
  if (!Array.isArray(hierarchy)) {
    return [];
  }
  return hierarchy
    .filter(isProductCategoryNotFromReceta)
    .map((category) => ({
      ...category,
      subcategories: (category.subcategories || [])
        .filter(isProductSubcategoryNotFromReceta)
        .map((subcategory) => ({
          ...subcategory,
          families: (subcategory.families || []).filter(isProductFamilyNotFromReceta),
        })),
    }));
}
